<!-- filter options for view steps -->
@if (orderShipmentGroups().length > 0) {
<div class="flex-layout" id="view-step-filter">
  <mat-form-field class="item-grow view-step-select">
    <mat-label>View Step</mat-label>
    <mat-select [value]="viewStep()" (selectionChange)="selectViewStep($event.value)">
      <mat-option [value]="lineStatuses.All">All</mat-option>
      @for (orderStep of expandButtons(); track orderStep) {
      <mat-option [value]="orderStep">{{ orderUtilityService.mapOrderShipmentStatus(orderStep) }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="section-buttons">
    <button mat-raised-button color="secondary" (click)="collapseAll()">
      <mat-icon>unfold_less</mat-icon>
      <span>Collapse All</span>
    </button>
    <button mat-raised-button color="secondary" (click)="expandAll()">
      <mat-icon>unfold_more</mat-icon>
      <span>Expand All</span>
    </button>
  </div>
</div>
}

<!-- Group status view type display-->
@for (group of orderShipmentGroups(); track group.status) {
<!-- don't do animations with isAnimated. it doesn't seem to work well and is very slow -->
<accordion [isAnimated]="false">
  <accordion-group [hidden]="!(group.orderShipments.length > 0)"
                   [isOpen]="isExpanded(group.status)"
                   (isOpenChange)="toggleSection(group.status, $event)">
    <span accordion-heading>
      <span>{{ orderUtilityService.mapOrderShipmentStatus(group.status) }}</span>
      <span class="item-count">({{ group.orderShipments.length }} items)</span>
    </span>

    <div class="flex-layout column stretch-items no-gap">
      @for (orderShipment of group.orderShipments; track orderShipment) {
      <insight-order [isSelected]="isOrderCurrentlySelected(orderShipment)"
                     (selectedOrderEvent)="clickedOrderToLoad($event)"
                     [orderScreen]="orderScreens.Dashboard"
                     [orderShipment]="orderShipment"></insight-order>
      }
    </div>
  </accordion-group>
</accordion>
}
